import { useQuery, useMutation } from "react-query";
import axiosInstance from "./httpService";
import { errorToast } from "utils/hooks";
import axios from "axios";

export const useQueryWrapper = (key: string, url: string, options?) => {
  const getAPICalls = async () => {
    const { data } = await axiosInstance.get(url);
    return data;
  };
  return useQuery(key, getAPICalls, options);
};

export const useAbQueryWrapper = (key: string, url: string, options?) => {
  const getAPICall = async () => {
    const {
      data: { data },
    } = await axiosInstance.get(url);
    return data;
  };
  return useQuery(key, getAPICall, options);
};

export const useAustinQueryWrapper = (key: string, url: string, options?) => {
  const getAPICall = async () => {
    const {
      data: { data },
      // } = await axiosInstance.get(url);
    } = await axios.get(url);
    return data;
  };
  return useQuery(key, getAPICall, options);
};

export const postRequest = async ({ url, data }) => {
  const response = await axiosInstance.post(url, data);
  return (response?.data as boolean) || response;
};

export const putRequest = async ({ url, data }) => {
  const response = await axiosInstance.put(url, data);
  return (response?.data as boolean) || response;
};
export const patchRequest = async ({ url, data }) => {
  const response = await axiosInstance.patch(url, data);
  return (response?.data as boolean) || response;
};

export const deleteRequest = async ({ url, data }) => {
  const config = { data };
  const response = await axiosInstance.delete(url, config);
  return (response?.data as boolean) || response;
};

// TODO: write JSDocs for this function
export const useMutationWrapper = (requestType, onSuccess?, onError?): any => {
  return useMutation(requestType, {
    onSuccess: (res) => {
      if (onSuccess) {
        onSuccess(res);
      }
    },

    onError: (error: any) => {
      if (onError) {
        onError(error);
      } else {
        const err = error as Record<any, any>;
        let message = err?.response?.data?.error;
        // sometimes the API send an array as JSON error message
        if (message.includes("[")) {
          message = JSON.parse(message);
        }
        message = Array.isArray(message) ? message[0] : message;
        errorToast(`${String(message) ?? "An error occured"}`);
      }
    },
  });
};
